(function () {
  'use strict';

  var RULES = {};

  function currencyFor(wrap) {
    var fromWrap = wrap && wrap.getAttribute('data-currency-code');
    var fromShopify = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var fromConfig = window.AubrielleRosewood && window.AubrielleRosewood.currency;
    return String(fromShopify || fromWrap || fromConfig || 'EUR').toUpperCase();
  }

  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = scope.querySelectorAll('.geo-shipping-wrap');

    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var code = currencyFor(wrap);
      var rule = RULES[code];
      var text = wrap.querySelector('.geo-shipping-text');
      if (!text) continue;

      wrap.setAttribute('data-currency-code', code);
      wrap.setAttribute('data-base-threshold', '0');

      var expected = 'Free shipping on every order';
      var current = (text.textContent || '').replace(/\s+/g, ' ').trim();

      if (current !== expected) {
        text.textContent = expected;
      }
    }

    if (document.documentElement) {
      document.documentElement.classList.add('ab-exact-shipping-ready');
    }
  }

  function syncSoon(root) {
    if (window.queueMicrotask) {
      window.queueMicrotask(function () { sync(root || document); });
    } else {
      Promise.resolve().then(function () { sync(root || document); });
    }
  }

  if ('MutationObserver' in window && document.documentElement) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var target = mutation.target;

        if (target && target.nodeType === 1 &&
            (target.matches('.geo-shipping-wrap, .geo-shipping-text') || target.closest('.geo-shipping-wrap'))) {
          sync(document);
          return;
        }

        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1 &&
                (node.matches('.geo-shipping-wrap') || node.querySelector('.geo-shipping-wrap'))) {
              sync(document);
              return;
            }
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncSoon(event.target || document);
  });

  document.addEventListener('shopify:section:select', function (event) {
    syncSoon(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(document); }, { once: true });
  } else {
    sync(document);
  }

  [50, 200, 600, 1200].forEach(function (delay) {
    window.setTimeout(function () { sync(document); }, delay);
  });
})();
